import { render, staticRenderFns } from "./SkeltonDetailsProfile.vue?vue&type=template&id=1bcd4854&scoped=true&"
import script from "./SkeltonDetailsProfile.vue?vue&type=script&lang=js&"
export * from "./SkeltonDetailsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd4854",
  null
  
)

export default component.exports